import React from 'react';

interface ProgressBarProps {
    progress: number;
    currentStep: number;
    totalSteps: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, currentStep, totalSteps }) => {
    const stepWidth = 100 / totalSteps;
    
    return (
        <div className="relative">
            {/* Active step indicator */}
            <div 
                className="absolute top-[0.1rem] h-1 bg-primary-color transition-all rounded-full duration-300 ease-in-out"
                style={{ 
                    width: `${stepWidth}%`,
                    left: `${(currentStep - 1) * stepWidth}%`,
                    display: currentStep === 1 ? 'none' : 'block',
                    filter: 'brightness(0.7)'
                }}
            />
            
            {/* Progress bar */}
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden p-[1px]">
                <div
                    className="h-full bg-primary-color transition-all rounded-full duration-300 ease-in-out"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
